// extracted by mini-css-extract-plugin
export default {"root":"CreateQRCodeView_root__x-eSI"};